import { LOGGED_USER } from "../variables/constants";

// Utilisateur courant : on lit en PRIORITÉ le snapshot de session le plus à jour (sessionStorage,
// réécrit à la connexion / mise à jour du profil), avec repli sur LOGGED_USER (constante figée au
// chargement du bundle). Évite qu'une dérogation accordée soit invisible tant que le module n'est
// pas rechargé.
const currentUser = () => {
    try {
        const raw = sessionStorage.getItem("user");
        if (raw) {
            return JSON.parse(raw);
        }
    } catch (e) {
        /* JSON invalide → repli */
    }
    return LOGGED_USER;
};

export const rightsService = (codeHabilitation) => {
    const user = currentUser();
    // Habilitations du profil — COPIE (ne jamais muter le tableau d'origine : l'ancienne version
    // faisait allHabs.push(derogation) → doublons cumulés + crash si habilitations null).
    const habs = [...(user?.profil?.habilitations || [])];
    // + Dérogations ACTIVES (non expirées).
    if (
        user?.derogation?.length &&
        user?.dateFinDerogation &&
        new Date(user.dateFinDerogation) > new Date()
    ) {
        habs.push(...user.derogation);
    }
    return habs.some((h) => h && h.codeHabilitation === codeHabilitation);
};

// Bureau direct : sous-siège de la compagnie.
export const estBureauDirect = () => currentUser()?.agence?.typeAgence === "BUREAU_DIRECT";

// Choisir un COURTIER comme agence de production (« Vous produisez pour », agence ciblée des
// avenants et du renouvellement) : siège, bureau direct ou utilisateur sans agence (Pool). Une
// agence ordinaire produit pour elle-même. Même règle côté serveur
// (ContratService.ensurePeutCiblerCourtier). N'ouvre PAS les autres droits du siège : le taux de
// commission reste figé et les autres agences restent soumises à HLA068.
export const peutProduirePourCourtier = () => {
    const agence = currentUser()?.agence;
    return !agence || agence.typeAgence === "SIEGE" || estBureauDirect();
};

// Taux de retenue fiscale : administrateur du SIÈGE seulement (habilitation HPE101 + rattaché au
// siège ou sans agence). Une compagnie règle ses agences et ses intermédiaires ; le Pool règle les
// courtiers. Même règle côté serveur (RetenueFiscaleService.peutModifierTaux).
export const peutModifierRetenueFiscale = () => {
    const agence = currentUser()?.agence;
    return rightsService("HPE101") && (!agence || agence.typeAgence === "SIEGE");
};

// Organisme de l'utilisateur courant (périmètre du taux de retenue fiscale).
export const codeOrganismeCourant = () => currentUser()?.profil?.organisme?.code;
